import { useCallback, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../../context';
import { storyCardApi } from '../../services';
import { layoutPath } from '../utils';

export const useRefreshStoryCardsUserStats = () => {
  const { pathname } = useLocation();

  const [userFeedStatistic] = storyCardApi.endpoints.storiesCardsUserFeedStatistic.useLazyQuery();

  const { userInfo, userProfile } = useContext(UserContext);

  const { channelId } = userInfo.userData;

  const { id: userId } = userProfile;

  const refreshStoryCardsUserStats = useCallback(() => {
    if (pathname !== layoutPath('/profile')) {
      return;
    }

    userFeedStatistic({ channelId, userId });
  }, [channelId, pathname, userFeedStatistic, userId]);

  return { refreshStoryCardsUserStats };
};
